import { createReducer } from '@reduxjs/toolkit'
import { setCompany, setDriver } from './actions'

const finalizedDelivery = createReducer({company: {}, driver: {}}, {
  [setCompany]: (state, action) => { state.company = action.payload },
  [setDriver]: (state, action) => { state.driver = action.payload }
})

export default finalizedDelivery